import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-my",
  "use": "icon-my-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-my\">\n    <title>icon/基础图标/我的</title>\n    <g id=\"icon-my_icon/基础图标/我的\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M48,46 C57.3888,46 65,38.3888 65,29 C65,19.6112 57.3888,12 48,12 C38.6112,12 31,19.6112 31,29 C31,38.3888 38.6112,46 48,46 Z\" id=\"icon-my_路径备份\" stroke=\"#2C2C2E\" stroke-width=\"10\" stroke-linejoin=\"round\" />\n        <path d=\"M48,51 C65.1208272,51 79,64.8791728 79,82 L79,85 L79,85 L17,85 L17,82 C17,64.8791728 30.8791728,51 48,51 Z\" id=\"icon-my_矩形\" stroke=\"#2C2C2E\" stroke-width=\"10\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/my.svg
// module id = kBws
// module chunks = 3